import { injectable } from "inversify";
import { CSATGatewayHandlers, ICSATHandler } from "../ports/CSATHandler";
import { ISalvarAvaliacaoCSATGateway } from "../ports/SalvarAvaliacaoCSATGateway";

@injectable()
export abstract class AbstractCSATGatewayHandler<T> implements ICSATHandler<T> {
  private next: ICSATHandler<T> | null = null;

  seNext(next: ICSATHandler<T>): ICSATHandler<T> {
    this.next = next;

    return next;
  }

  handle(tipo: CSATGatewayHandlers): null | ISalvarAvaliacaoCSATGateway<T> {
    if (this.next) {
      return this.next.handle(tipo);
    }

    return null;
  }
}
